module.exports = __webpack_public_path__ + "img/logo-v.e5c54312.svg";